/**
 * Three muted dots that fade in/out together. No bounce — the brand does not
 * jiggle. Calm 1.4s loop, low-amplitude opacity.
 */
export function TypingIndicator() {
  return (
    <div
      aria-label="agent is typing"
      style={{
        alignSelf: 'flex-start',
        display: 'flex',
        gap: '6px',
        padding: '14px 16px',
        background: 'var(--paper-2)',
        borderRadius: '18px 18px 18px 4px',
        border: '1px solid var(--rule)',
      }}
    >
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          style={{
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: 'var(--muted)',
            animation: `typing-fade 1.4s ease-in-out ${i * 0.2}s infinite`,
          }}
        />
      ))}
      <style>{`
        @keyframes typing-fade {
          0%, 60%, 100% { opacity: 0.25; }
          30% { opacity: 1; }
        }
      `}</style>
    </div>
  );
}
